export const calculateTotalAmountData = (userData) => {
    let totalAmount = 0;
    let amounts = [];

    // Helper function to process a user or dependent
    const processMember = (member) => {
        if (!member.isActiveMember && Array.isArray(member.products)) {
            member.products
                .filter((product) => product.selected === true)
                .forEach((product) => {
                    amounts.push({
                        memberId: member.id || member.dependentId,
                        label: `${member?.lastName} ${member?.firstName} - ${product.label}`,
                        amount: product?.discount ? product.unitPrice - product.unitPrice * product?.discount * 0.01 : product.unitPrice
                    });
                    totalAmount += product?.discount ? product.unitPrice - product.unitPrice * product?.discount * 0.01 : product.unitPrice;
                });
        }
    };

    // Process main user
    processMember(userData);

    // Process dependents
    if (Array.isArray(userData.dependents)) {
        userData.dependents.forEach((dependent) => processMember(dependent));
    }

    return { totalAmount, amounts };
};
